import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, ChevronRightIcon, PlusIcon, SearchIcon } from 'lucide-react';
import { FoundPetDialog } from '../components/animaux/FoundPetDialog';
import { PetAtna, PetRules } from '../components/animaux/PetAtna';
import { VetConnect } from '../components/animaux/VetConnect';
import { petTodos, pets } from '../data/animaux';
export function MesAnimaux() {
  const [foundOpen, setFoundOpen] = useState(false);
  const todos = pets.flatMap(pet => (petTodos[pet.id] ?? []).map(todo => ({
    ...todo,
    pet
  })));
  return <main className="bg-white" data-id="element-2889" data-mp="20n7l9jzx111h">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2890" data-mp="20ld0c5on98xe">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2891" data-mp="1vnbh9kr7x9lx">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2892" data-mp="2ak2kk540j5gt">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2893" data-mp="25nc4viw4ebvx" />
          <span aria-current="page" data-id="element-2894" data-mp="1jl05tjngwppg">Mes animaux</span>
        </nav>

        <header className="mt-4" data-id="element-2895" data-mp="1ojbg1vhod287">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2896" data-mp="1okcqbxqv9kov">Mes animaux</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-2897" data-mp="1sk52ekfgy8yz">
            Vos animaux, leurs médailles et ce qui compte — au même endroit.
          </p>
        </header>

        <div className="mt-8" data-id="element-2898" data-mp="22jm7p0qt6kuf">
          <PetAtna data-id="element-2899" data-mp="22ikuoqq8foa2" />
        </div>

        <section aria-labelledby="animaux-titre" className="mt-14" data-id="element-2900" data-mp="22h9oyld886gb">
          <h2 id="animaux-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-2901" data-mp="27gmdrbnnrnlj">
            Mes animaux
          </h2>

          <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-2902" data-mp="2gahg6bxeazxh">
            {pets.map(pet => <li key={pet.id} className="flex" data-id="element-2903" data-mp="2l9lshbfm9ds1">
                <Link to={`/mes-animaux/${pet.id}`} className="group flex w-full items-center gap-4 rounded-3xl border border-slate-200 bg-white p-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2904" data-mp="2lawt52drm5ex">
                  <img src={pet.photo} alt={pet.name} className="h-24 w-24 shrink-0 rounded-2xl object-cover" data-id="element-2905" data-mp="zw8lv7jsm03d" />
                  <div className="min-w-0 flex-1" data-id="element-2906" data-mp="v5s97pnsqii2">
                    <p className="text-lg font-extrabold text-ville-navy" data-id="element-2907" data-mp="v3xoocgfssei">{pet.name}</p>
                    <p className="text-sm text-slate-500" data-id="element-2908" data-mp="18vlw42fqqsp5">
                      {pet.breed} · {pet.age}
                    </p>
                    <p className="mt-2 inline-flex rounded-full bg-ville-indigo-soft px-3 py-1 text-xs font-bold text-ville-indigo" data-id="element-2909" data-mp="14xeez6hd7pdf">
                      Médaille active
                    </p>
                    <p className="mt-2 font-mono text-xs tracking-widest text-slate-500" data-id="element-2910" data-mp="1dtx7ihlopb9h">{pet.medal}</p>
                    <p className="text-xs text-slate-500" data-id="element-2911" data-mp="3kok8nlbau3et">Validité : {pet.validUntil}</p>
                    <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-2912" data-mp="3fp7juv0vam9l">
                      Voir la carte
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2913" data-mp="2069njn68u3ah" />
                    </span>
                  </div>
                </Link>
              </li>)}

            <li className="flex" data-id="element-2914" data-mp="1qcj26r5ey8z0">
              <button type="button" className="flex w-full items-center gap-4 rounded-3xl border-2 border-dashed border-slate-300 p-6 text-left text-slate-500 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2915" data-mp="1cf47p80azb06">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-slate-50" aria-hidden="true" data-id="element-2916" data-mp="17hkw6fuzpcbx">
                  <PlusIcon className="h-6 w-6" data-id="element-2917" data-mp="31tsij4t8wkw3" />
                </span>
                <span className="text-[15px] font-bold text-ville-navy" data-id="element-2918" data-mp="31szjyr4fx1p1">Ajouter un animal</span>
              </button>
            </li>

            <li className="flex" data-id="element-2919" data-mp="xq7i59fm3t3w">
              <button type="button" onClick={() => setFoundOpen(true)} className="flex w-full items-center gap-4 rounded-3xl border-2 border-dashed border-slate-300 p-6 text-left text-slate-500 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2920" data-mp="xr94wb5zq41g">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-slate-50" aria-hidden="true" data-id="element-2921" data-mp="e0nnd2wd0lev">
                  <SearchIcon className="h-6 w-6" data-id="element-2922" data-mp="9xzckpo354f9" />
                </span>
                <span data-id="element-2923" data-mp="52tszxi5o1uc">
                  <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2924" data-mp="4zfoaim0rgjq">Animal trouvé</span>
                  <span className="block text-sm text-slate-500" data-id="element-2925" data-mp="40dy0n802s2">Scanner son collier ou signaler</span>
                </span>
              </button>
            </li>
          </ul>
        </section>

        <section aria-labelledby="a-faire-titre" className="mt-14" data-id="element-2926" data-mp="3h6mss8osfa38">
          <h2 id="a-faire-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-2927" data-mp="3m2bvum00n94a">
            À faire
          </h2>
          {todos.length === 0 ? <p className="mt-3 flex items-center gap-2 text-sm text-slate-500" data-id="element-2928" data-mp="3w22osj8xhg29">
              <CheckIcon className="h-4 w-4 text-ville-indigo" aria-hidden="true" data-id="element-2929" data-mp="2yeaohgekpyqg" />
              Tout est à jour.
            </p> : <ul className="mt-5 space-y-3" data-id="element-2930" data-mp="33dnbc15g35t1">
              {todos.map(todo => <li key={`${todo.pet.id}-${todo.id}`} data-id="element-2931" data-mp="38b6zptvuwyyp">
                  <Link to={`/mes-animaux/${todo.pet.id}`} className="group flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2932" data-mp="3d2ygjcp7nqbn">
                    <img src={todo.pet.photo} alt="" className="h-11 w-11 shrink-0 rounded-full object-cover" data-id="element-2933" data-mp="2ck51drpp9e3s" />
                    <span className="min-w-0 flex-1" data-id="element-2934" data-mp="27ksgvdmawj4d">
                      <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2935" data-mp="2mc13reytjqdt">
                        {todo.title} — {todo.pet.name}
                      </span>
                      <span className="block text-sm text-slate-500" data-id="element-2936" data-mp="1tn3qxrddmlsg">{todo.detail}</span>
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-2937" data-mp="1ooirvv9v285l">
                      {todo.cta}
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2938" data-mp="1ylx6dpc84mv9" />
                    </span>
                  </Link>
                </li>)}
            </ul>}
        </section>

        <PetRules data-id="element-2939" data-mp="3a0aki2h6dny3" />
        <VetConnect data-id="element-2940" data-mp="3a12dr6nav9l7" />
      </div>

      <FoundPetDialog open={foundOpen} onClose={() => setFoundOpen(false)} data-id="element-2941" data-mp="3hkuw3r3hamc5" />
    </main>;
}